import Map from '../util/map';


class ShowroomContoller {

    constructor() {

        this.setSlider();
        this.setMap();
        this.setMapYokohama();
        
    }
    setSlider() {
        let options = {
            preloadImages: false,
            lazy: true,
            loop: true,
            // loopAdditionalSlides: 1,
            // freeMode: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            // centeredSlides: true,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            // spaceBetween:  (window.UA.isSP)? 25: 40,
            slidesPerView: 1,
            // preventClicks: false,
            // preventClicksPropagation: false,
            // preventInteractionOnTransition: true,
            // slidesPerGroup: 1,
            // slideToClickedSlide: true,
            navigation: {
                nextEl: '#js-showroom-content__slider-next',
                prevEl: '#js-showroom-content__slider-prev',
            },
            // scrollbar: {
            //     el: '#js-renovation-case-detail__slider-bar',
            //     // hide: true,
            //     draggable: true,
            // },
            touchAngle: 20,
            speed: 250,
            pagination: {
                el: '#js-showroom-content__slider-pagination',
                clickable: true,
                // renderBullet: function (index, className) {
                //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
                // },
                // bulletClass: 'mainvisual__slider-pagination-bullet',
                // bulletActiveClass: 'is-active'
            },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {},
            // thumbs: {
            //     swiper: this.thumbSlider,
            // },
        };
        this.mainSlider = new Swiper(
            '#js-showroom-content__slider',
            options
        );
        if (window.UA.isSP) {
            this.mainSlider.off('resize');
        }
    }


    setMap() {
        let map = new Map(
            'js-showroom-index__section-map-canvas',
            'ARISE RENOVE LOUNGE小石川'
        );
    }

    setMapYokohama() {
        let map = new Map(
            'js-showroom-index__section-map-canvas2',
            '株式会社エフステージ横浜支店'
        );
    }
}

export default ShowroomContoller;
